'use client';

import { useEffect } from 'react';

// When the viewport is resized across a media-query breakpoint, any element
// whose transitioned properties (opacity, max-height, padding, transform …)
// differ between breakpoints animates that jump — which reads as a flash while
// dragging the window across the boundary. While the window is actively being
// resized we add a marker class to <body> so those transitions can be switched
// off (see navbar.scss), then remove it shortly after resizing settles. This is
// the well-known "resize animation stopper" pattern.
const RESIZE_SETTLE_MS = 300;

export const useResizeTransitionGuard = (): void => {
  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }

    let settleTimeout: ReturnType<typeof setTimeout>;

    const handleResize = (): void => {
      document.body.classList.add('is-resizing');
      clearTimeout(settleTimeout);
      settleTimeout = setTimeout(() => {
        document.body.classList.remove('is-resizing');
      }, RESIZE_SETTLE_MS);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
      clearTimeout(settleTimeout);
      document.body.classList.remove('is-resizing');
    };
  }, []);
};
